module.exports = __webpack_public_path__ + "static/media/user-times.15156e97.svg";